import React from "react";

import RatingItem from "./item-types/RatingItem";
import RangeItem from "./item-types/RangeItem";
import MultiChoiceOneItem from "./item-types/MultiChoiceOneItem";
import MultiChoiceManyItem from "./item-types/MultiChoiceManyItem";
import FreeTextItem from "./item-types/FreeTextItem";

const SurveyItemBody = props => {
  switch (props.surveyItem.itemType) {
    case "rating":
      return <RatingItem {...props} />;
    case "range":
      return <RangeItem {...props} />;
    case "multi_choice_one":
      return <MultiChoiceOneItem {...props} />;
    case "multi_choice_many":
      return <MultiChoiceManyItem {...props} />;
    case "free_text":
      return <FreeTextItem {...props} />;
    default:
      return null;
  }
};

const SurveyItem = ({ surveyItem, itemNumber, ...props }) => (
  <div className="SurveyItemSingle clearfix">
    <h2 className="prompt">{itemNumber && `Q${itemNumber}. `}{surveyItem.prompt}</h2>
    <SurveyItemBody surveyItem={surveyItem} {...props} />
  </div>
);

export default SurveyItem;
